import { useContext } from "react";
import { EPDStyleContext } from "./EPDStyleContext";

export function useEPDStyle() {
  const context = useContext(EPDStyleContext);
  if (!context) {
    throw new Error("useEPDStyle must be used within a EPDStyleProvider");
  }
  return context;
}
